// extracted by mini-css-extract-plugin
export default {"container":"LanguageSwitcher_container__EnATP","button":"LanguageSwitcher_button__uH6t+","buttonActive":"LanguageSwitcher_buttonActive__OIyaD"};